
define(
	'Tavanoteam.Prop65Warning.Prop65Warning'
	, [
		'Tavanoteam.Prop65Warning.Prop65Warning.View'
	]
	, function (
		Prop65WarningView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layout = container.getComponent('Layout');

				if (layout) {
					layout.addChildView('Product.Information', function () {
						return new Prop65WarningView({ container: container });
					});
				}

			}
		};
	});
